export default __webpack_public_path__ + "static/winter7-66c89c0b6327c19c4a4cef738951ca5a.webp";